// A browser tab is never launched by a notification tap, because it never receives one: the web
// build registers no push device at all (see lib/push-notifications.web.ts), so there is nothing
// for the OS to deliver and nothing for a listener to hear. expo-notifications has no web
// implementation of either call, so the honest web answer is silence rather than a shim that
// pretends. Every export mirrors the native module so callers never branch on the platform.
//
// Deep links themselves still work on web — they arrive as URLs, which expo-router handles on its
// own — and the pending-route stash is platform-free, so a browser deep link opened while logged
// out is still replayed after login.

export function addNotificationTapListener(_onTap: (tap: {id: string; data: unknown}) => void): () => void {
    return () => {
        // Nothing was subscribed.
    };
}

export async function getInitialNotificationTap(): Promise<{id: string; data: unknown} | null> {
    return null;
}
